import React, { FunctionComponent } from "react";
import { zip } from "lodash";

import {
  TableRowProps,
  Th,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";

import { JSONArray, SharedProps } from "./types";

import ValuesChartRow from "./ValuesChartRow";
import ValuesHeatmapRow from "./ValuesHeatmapRow";
import RowValue from "./RowValue";


interface IProps extends TableRowProps, SharedProps {
  label: string;
  units?: string;
  values: JSONArray;
  corrections?: number[];
  withoutChart?: boolean;
  withoutValues?: boolean;
  nowHourIndex: number;
  colors?: string[];
  multiplier?: number;
  signedValues?: boolean;
}


const RowOfValues: FunctionComponent<IProps> = ({
  label,
  units,
  values,
  corrections = [],
  cellWidth,
  cellPaddingX,
  nowHourIndex,
  colors = [],
  withoutChart = false,
  withoutValues = false,
  multiplier = 1,
  signedValues = false,
  children,
  ...rest
}) => {
  return (
    <>
      {!withoutChart && <ValuesChartRow {...{label, values: values as number[], corrections, colors, units, cellWidth, cellPaddingX, nowHourIndex, children}} />}
      {colors.length === 2 && <ValuesHeatmapRow {...{values, corrections, colors}} />}
      <Tr {...rest}>
        <Th pt={0} position="sticky" left={0} bg={useColorModeValue("white", "gray.950")} dangerouslySetInnerHTML={{ __html: label}} whiteSpace="nowrap"/>
        {corrections && zip(values, corrections).map(([value, correction], index) => <RowValue key={index} isCurrentHour={nowHourIndex === index} {...{label, value, correction, multiplier, units, cellWidth, cellPaddingX, withoutValue: withoutValues, signedValue: signedValues}} /> )}
        {!corrections && values.map((value, index) => <RowValue key={index} isCurrentHour={nowHourIndex === index} {...{label, value, multiplier, units, cellWidth, cellPaddingX, withoutValue: withoutValues, signedValue: signedValues}} /> )}
      </Tr>
    </>
  )
}

export default RowOfValues;
